import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import {
  PoSettlementDetail,
  PoSettlementRow,
  PoSettlementSummary,
  PurchaseOrderSettlementSearch,
} from '../models/po-settlement/po-settlement';
import { PagedResult } from './bank-account.proxy.service';

@Injectable({ providedIn: 'root' })
export class PoSettlementProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/ap/po-settlement';

  /** Paginated per-PO settlement rows. */
  public search(
    command: PurchaseOrderSettlementSearch,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PagedResult<PoSettlementRow>>> {
    let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize).set('sortOrder', sortOrder);
    if (sortField) params = params.set('sortField', sortField);
    return this.httpClient.post<ApiResponse<PagedResult<PoSettlementRow>>>(`${this.baseUrl}/search`, command, {
      params,
    });
  }

  /** Dashboard summary cards + "By provider" rollup over the full filtered PO set. */
  public getSummary(command: PurchaseOrderSettlementSearch): Observable<ApiResponse<PoSettlementSummary>> {
    return this.httpClient.post<ApiResponse<PoSettlementSummary>>(`${this.baseUrl}/summary`, command);
  }

  /** Per-PO detail: AP-document breakdown + activity timeline. */
  public getDetail(purchaseOrderId: string): Observable<ApiResponse<PoSettlementDetail>> {
    return this.httpClient.get<ApiResponse<PoSettlementDetail>>(`${this.baseUrl}/${purchaseOrderId}`);
  }
}
